import { createGlobalStyle } from 'styled-components'

export const cores = {
  laranja: '#fe6613',
  azul: '#1b2653',
  cinza: '#787878',
  laranjaEscuro: 'rgba(255, 50, 0, 0.8)',
  azulClaro: '#4f8df9',
  vermelho: 'red',
  branco: '#fff',
  preto: '#000'
}

export const breackpoints = {
  desktop: '1100px',
  tablet: '768px'
}

export const EstiloGlobal = createGlobalStyle`
  *{
    margin: 0;
    padding: 0;
    box-sizing: border-box;
    list-style: none;
    text-decoration: none;
    font-family: "Roboto", sans-serif;
  }

  .container {
    max-width: ${breackpoints.desktop};
    width: 100%;
    margin: 0 auto;
  }
`
